import React, { useState, Component, useEffect } from "react";
import { Grid, Paper } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import Button from '@material-ui/core/Button';
import logo from "./icon.png";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import useStyles from "./styles";
import App from "../../App";
import { useUserDispatch, EnterpriseLogin } from "../../context/UserContext";

export default function RedirectPage(props) {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [onLoad, setOnLoad] = React.useState(0);
  const [tokenId, setTokenId] = React.useState('')
  const [org, setOrg] = React.useState('')
  const { enqueueSnackbar } = useSnackbar();
  const [onRedirectData, setOnRedirectData]= React.useState(false)
  var [isLoading, setIsLoading] = useState(false);
  var [error, setError] = useState(null);
  var userDispatch = useUserDispatch();
  
  useEffect(() => {
    setTokenId(props.match.params.token)
    localStorage.setItem('id_token', props.match.params.token)
    localStorage.setItem('organization', props.match.params.organization)
    localStorage.setItem('email', props.match.params.username)
    axios.defaults.headers.common["Authorization"] = "JWT " + props.match.params.token;
    setOnRedirectData(true)
  }, [onLoad]);

  useEffect(() => {
    if(onRedirectData){
      EnterpriseLogin(props.match.params.organization, props.match.params.username, props.match.params.token, setIsLoading, setError, userDispatch)    
      // axios.get(`${props.match.params.organization}/users/${props.match.params.username}`)
      // .then(res => {
      //   localStorage.setItem('first_name', res.data.user.first_name)
      //   localStorage.setItem('last_name', res.data.user.last_name)
      //   if(res.data){
      //   }        
      // }).catch(err => {
      //   //enqueueSnackbar('Cannot redirect to site', { variant: 'warning' });
      // });
    }
  }, [onRedirectData]);
  return (
    <Grid container className={classes.container}>
      <div className={classes.root}>
      </div>
      <Paper classes={{ root: classes.paperRoot }}>
        <img src={logo} alt="logo" className={classes.logotypeImage} />
        <div className={classes.textVerifyEmail}>
          Redirecting to site.... 
        </div>
      </Paper>
    </Grid>

  )
};